<template>
  <div class="home">
    <div style="text-align: right; padding: 10px">
      <el-button type="primary" icon="el-icon-sort" @click="switchTenants" plain v-if="tenant">{{ all ? "所有基地" : tenant
        }}
      </el-button>
      <el-button type="primary" icon="el-icon-switch-button" @click="signOut" plain>Sign Out
      </el-button>
    </div>
    <div class="content">
      <el-row :gutter="12">
        <template v-for="(item, i) in listData">
          <el-col v-if="item == 'fr'" :span="24" :key="i">
            <el-button icon="el-icon-edit-outline" size="medium" type="primary" plain @click="frRouter">快反看板
            </el-button>
          </el-col>
          <el-col v-if="item == 'fr'" :span="24" :key="i + 'q'">
            <el-button icon="el-icon-edit-outline" size="medium" type="primary" plain @click="qplotRouter">快反质量Q图
            </el-button>
          </el-col>
          <el-col v-if="item == 'andon'" :span="24" :key="i">
            <el-button icon="el-icon-edit-outline" size="medium" type="primary" plain @click="andonRouter">安灯看板
            </el-button>
          </el-col>
          <el-col v-if="item == 'layeraudit'" :span="24" :key="i">
            <el-button icon="el-icon-edit-outline" size="medium" type="primary" plain @click="lpaRouter">分层审核
            </el-button>
          </el-col>
          <el-col v-if="item == 'ehs'" :span="24" :key="i">
            <el-button icon="el-icon-edit-outline" size="medium" type="primary" plain @click="ehsRouter">EHS
            </el-button>
          </el-col>
          <el-col v-if="item == 'ei'" :span="24" :key="i">
            <el-button icon="el-icon-edit-outline" size="medium" type="primary" plain @click="eiRouter">EI
            </el-button>
          </el-col>
          <el-col v-if="item == 'nok'" :span="24" :key="i">
            <el-button icon="el-icon-edit-outline" size="medium" type="primary" plain @click="nokRouter">不合格品
            </el-button>
          </el-col>
          <el-col v-if="item == 'cpm' || item == 'change'" :span="24" :key="i">
            <el-button icon="el-icon-edit-outline" size="medium" type="primary" plain @click="cpmRouter">变化点
            </el-button>
          </el-col>
          <el-col v-if="item == 'oee'" :span="24" :key="i + 'oe'">
            <el-button icon="el-icon-edit-outline" size="medium" type="primary" plain @click="oeeRouter">KPI可视化
            </el-button>
          </el-col>
          <el-col v-if="item == 'oee'" :span="24" :key="i + 'm'">
            <el-button icon="el-icon-edit-outline" size="medium" type="primary" plain @click="oeeMmRouter">管理者会议
            </el-button>
          </el-col>
          <el-col v-if="item == 'escalation'" :span="24" :key="i">
            <el-button icon="el-icon-edit-outline" size="medium" type="primary" plain @click="escalationRouter">升级流程
            </el-button>
          </el-col>
          <el-col v-if="item == 'fr_schedule'" :span="24" :key="i">
            <el-button icon="el-icon-edit-outline" size="medium" type="primary" plain @click="schedule">会议日程
            </el-button>
          </el-col>
        </template>
        <el-col :span="24">
          <el-button icon="el-icon-edit-outline" size="medium" type="primary" plain @click="boxRouter">看板轮播
          </el-button>
        </el-col>
        <!-- <el-col :span="24">
          <el-button
            icon="el-icon-edit-outline"
            size="medium"
            type="primary"
            plain
            @click="micKpiRouter"
          >MIC-KPI
          </el-button>
        </el-col> -->
        <el-col :span="24" v-if="listData.length < 1">
          <i style="cursor: pointer" class="el-icon-sunrise-1"></i>
          <el-button size="medium">未授权模块看板</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import API from "@/utils/api";
import router from "../../router";

export default {
  name: "home",
  data() {
    return {
      listData: [],
      tenant: null,
      all: false,
      host: null,
      username: null,
    };
  },
  mounted() {
    // 初始化
    var type = this.$route.query.type;
    this.host = this.getQueryVariable("host");
    this.username = this.getQueryVariable("username");
    this.all = type == "all";
    this.init();
  },
  methods: {
    signOut() {
      localStorage.removeItem("user_session");
      router.push("/login");
    },
    switchTenants() {
      router.push("/tenants");
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return null;
    },
    init() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        if (this.host || this.username) {
          router.push(`/login?host=${this.host}&username=${this.username}`);
        } else {
          router.push(`/login`);
        }
        return;
      } else {
        user = JSON.parse(user);
        this.tenant = user["tenant"];
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }

      API.getLic()
        .then((res) => {
          if (res.success == true) {
            var bean = res.value;
            var modules = bean["modules"] ? bean["modules"].split(",") : [];
            for (var i = 0; i < modules.length; i++) {
              modules[i] = modules[i].toLowerCase();
            }
            this.listData = modules;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          this.$message.error("网络错误,数据查询失败");
        });

      API.getSetting({ key: "app.kanban.self" })
        .then((res) => {
          if (res.success == true) {
            var bean = res.value;
            if (bean != null) {
              localStorage.setItem("kaban_self", bean["value"]);
            } else {
              localStorage.removeItem("kaban_self");
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          // this.$message.error("网络错误,数据查询失败");
        });
    },
    frRouter() {
      router.push("/fr/category");
    },
    schedule() {
      this.$router.push({
        path: "/fr/schedule",
        query: {
          key: this.$route.query.key,
        }
      });
    },
    andonRouter() {
      router.push("/andon/board");
    },
    andonDatav() {
      router.push("/andon/datav");
    },
    qplotRouter() {
      router.push("/fr/qplot");
    },
    cpmRouter(){
      router.push("/cpm/board");
    },
    lpaRouter() {
      if (this.all) {
        router.push("/layeraudit/category?type=all");
      } else {
        router.push("/layeraudit/category");
      }
    },
    ehsRouter() {
      router.push("/ehs/board");
    },
    eiRouter() {
      router.push("/ei/board");
    },
    nokRouter() {
      router.push("/nok/board");
    },
    oeeRouter() {
      router.push("/oee/board");
    },
    oeeMmRouter() {
      router.push("/oee/mm/category");
    },
    escalationRouter() {
      router.push("/escalation/board");
    },
    boxRouter() {
      router.push("/box/category");
    },
    micKpiRouter() {
      router.push("/mickpi/board");
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./home.css'></style>



// WEBPACK FOOTER //
// src/pages/home/home.vue